$(document).ready(function () {
    if ($('body #cache-next-session-date-modal').length) {
        $('#cache-next-session-date-modal').modal('show');
    }
});
